"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKpiWidgetDefinition = exports.isKpiWidget = exports.isInsightWidgetDefinition = exports.isInsightWidget = exports.widgetTitle = exports.widgetType = exports.widgetRef = exports.widgetUri = exports.widgetId = exports.isWidget = exports.isWidgetDefinition = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
/**
 * Type-guard testing whether the provided object is an instance of {@link IWidgetDefinition}.
 * @alpha
 */
function isWidgetDefinition(obj) {
    return hasWidgetProps(obj) && !sdk_model_1.isObjRef(obj.ref);
}
exports.isWidgetDefinition = isWidgetDefinition;
/**
 * Type-guard testing whether the provided object is an instance of {@link IWidget}.
 * @alpha
 */
function isWidget(obj) {
    return hasWidgetProps(obj) && sdk_model_1.isObjRef(obj.ref);
}
exports.isWidget = isWidget;
/**
 * @internal
 */
function hasWidgetProps(obj) {
    return (!isEmpty_1.default(obj) &&
        (obj.type === "kpi" || obj.type === "insight"));
}
/**
 * Gets the widget identifier
 *
 * @param widget - widget to get identifier of
 * @returns the widget identifier
 * @alpha
 */
function widgetId(widget) {
    ts_invariant_1.default(widget, "widget to get identifier of must be specified");
    return widget.identifier;
}
exports.widgetId = widgetId;
/**
 * Gets the widget uri
 *
 * @param widget - widget to get uri of
 * @returns the widget uri
 * @alpha
 */
function widgetUri(widget) {
    ts_invariant_1.default(widget, "widget to get uri of must be specified");
    return widget.uri;
}
exports.widgetUri = widgetUri;
/**
 * Gets the widget ref
 *
 * @param widget - widget to get ref of
 * @returns the widget ref
 * @alpha
 */
function widgetRef(widget) {
    ts_invariant_1.default(widget, "widget to get ref of must be specified");
    return widget.ref;
}
exports.widgetRef = widgetRef;
/**
 * Gets the widget type
 *
 * @param widget - widget to get type of
 * @returns the widget type
 * @alpha
 */
function widgetType(widget) {
    ts_invariant_1.default(widget, "widget to get type of must be specified");
    return widget.type;
}
exports.widgetType = widgetType;
/**
 * Gets the widget title
 *
 * @param widget - widget to get title of
 * @returns the widget title
 * @alpha
 */
function widgetTitle(widget) {
    ts_invariant_1.default(widget, "widget to get title of must be specified");
    return widget.title;
}
exports.widgetTitle = widgetTitle;
/**
 * Type-guard testing whether the provided object is an instance of {@link IInsightWidget}.
 * @alpha
 */
function isInsightWidget(obj) {
    return isWidget(obj) && obj.type === "insight";
}
exports.isInsightWidget = isInsightWidget;
/**
 * Type-guard testing whether the provided object is an instance of {@link IInsightWidgetDefinition}.
 * @alpha
 */
function isInsightWidgetDefinition(obj) {
    return isWidgetDefinition(obj) && obj.type === "insight";
}
exports.isInsightWidgetDefinition = isInsightWidgetDefinition;
/**
 * Type-guard testing whether the provided object is an instance of {@link IKpiWidget}.
 * @alpha
 */
function isKpiWidget(obj) {
    return isWidget(obj) && obj.type === "kpi";
}
exports.isKpiWidget = isKpiWidget;
/**
 * Type-guard testing whether the provided object is an instance of {@link IKpiWidget}.
 * @alpha
 */
function isKpiWidgetDefinition(obj) {
    return isWidgetDefinition(obj) && obj.type === "kpi";
}
exports.isKpiWidgetDefinition = isKpiWidgetDefinition;
//# sourceMappingURL=widget.js.map